module.exports = "/_next/static/images/vtc-c0d7306759f35d3d0ecca2718adc9395.svg";